import { useState, type FormEvent } from 'react';
import { cleanPlayerName, isValidGameCode, PLAYER_NAME_MAX_LENGTH, validatePlayerName } from '@secretnenshi/shared';
import { Button, Field, Page } from '../components/ui';
import { go, joinGame, requestReclaim, showNotice } from '../state/actions';
import { useStore } from '../state/store';

export function JoinGame({ initialCode = '', initialName = '' }: { initialCode?: string; initialName?: string }) {
  const busy = useStore((s) => s.busy);
  const [code, setCode] = useState(initialCode);
  const [name, setName] = useState(initialName);
  const [taken, setTaken] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setTaken(null);
    if (!isValidGameCode(code)) return showNotice({ kind: 'error', text: 'Game codes are six digits.' });
    const error = validatePlayerName(name);
    if (error) return showNotice({ kind: 'error', text: error });
    if ((await joinGame(code, name)) === 'name-taken') setTaken(cleanPlayerName(name));
  };

  return (
    <Page title="Join game" onBack={() => go({ name: 'landing' })}>
      <form className="form" onSubmit={submit}>
        <Field
          label="Game code"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="off"
          className="field-input code-input"
          autoFocus={!initialCode}
          required
        />
        <Field
          label="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={PLAYER_NAME_MAX_LENGTH}
          autoComplete="nickname"
          autoCapitalize="words"
          enterKeyHint="go"
          required
        />
        <Button type="submit" disabled={busy}>
          Join game
        </Button>
      </form>

      {taken ? (
        <div className="callout">
          <p>
            <strong>{taken}</strong> already has a seat in game {code}.
          </p>
          <p>If that’s you on a different phone, ask the host to let you back in.</p>
          <Button variant="secondary" disabled={busy} onClick={() => void requestReclaim(code, taken)}>
            Reclaim {taken}
          </Button>
        </div>
      ) : null}
    </Page>
  );
}
